import { Controller } from "@hotwired/stimulus"
import { Carousel } from "bootstrap"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.interval = Number.parseInt(this.element.dataset.bsInterval, 10) || 5000
    this.element.style.setProperty("--carousel-interval", `${this.interval}ms`)

    this.carousel = Carousel.getOrCreateInstance(this.element)
    this.boundOnSlide = this.onSlide.bind(this)
    this.element.addEventListener("slide.bs.carousel", this.boundOnSlide)
    this.carousel.cycle()
    this.startCountdown(this.tabTargets.indexOf(this.activeTab))
    this.setInactiveTabHeight()
  }

  disconnect() {
    this.element.removeEventListener("slide.bs.carousel", this.boundOnSlide)
    this.carousel?.dispose()
  }

  onSlide(event) {
    this.startCountdown(event.to)
  }

  startCountdown(index) {
    this.tabTargets.forEach(tab => tab.classList.remove("countdown-running"))

    const tab = this.tabTargets[index]
    if (!tab) return

    void tab.offsetWidth
    tab.classList.add("countdown-running")
  }

  setTabsHeight() {
    setTimeout(() => {
      this.setActiveTabHeight();
      this.setInactiveTabHeight();
    }, 0);
  }

  setActiveTabHeight() {
    this.setTabHeight(this.activeTab, ".tab-content");
  }

  setInactiveTabHeight() {
    this.inactiveTabs.forEach(tab => this.setTabHeight(tab, "h3"));
  }

  setTabHeight(tabElement, content) {
    let contentElement = tabElement.querySelector(content);
    if (contentElement) {
      tabElement.style.height = `${tabElement.querySelector(content).offsetHeight}px`;
    }
  }

  get activeTab() {
    return this.tabTargets.find(tab => tab.classList.contains("active"));
  }

  get inactiveTabs() {
    return this.tabTargets.filter(tab => !tab.classList.contains("active"));
  }
}
